import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {
  parseAuthQueryString,
  getToken,
  redirectToLogin,
  handleCode,
} from "./auth";

const root = ReactDOM.createRoot(document.getElementById("root"));
(async () => {
  try {
    const tokenData = parseAuthQueryString();
    if (tokenData) await handleCode(tokenData);
    const token = await getToken();
    if (!token) throw new Error("No token, auth required");
    root.render(<App />);
  } catch (e) {
    console.error(e);
    redirectToLogin();
  }
})();
